__turbopack_context__.v({
  "fadeIn": "BqozQG_fadeIn",
  "shippingLabel": "BqozQG_shippingLabel",
});
